import { HttpClient } from "_fil_local_addon/camc-cms-base/index";
import { FUND_API_SOURCES } from "_fil_local_addon/camc-cms-base/amc_fund_api.constant";
import { UrlTool } from "_fil_local_addon/camc-cms-base/index";
import FundReportService from "_fil_local_addon/camc-fund-report-list/fund_report_service";

class CAMCFundIndustryDistribution {
    constructor(fundCode) {
        this.fundCode = fundCode;
        this.reportTime = null;
        this.httpClient = new HttpClient();
        this.fund_portfolio_sector_api = FUND_API_SOURCES.FUND_PORTFOLIO_SECTOR_SOURCE;
    }

    async render() {
        try {
            this.reportTime = await FundReportService.getReportTime(this.fundCode);
            if (!this.reportTime) {
                this.setEmptyMessage();
                return;
            } else {
                const sectorData = await this.getSectorData();
                this.renderSectorData(sectorData);
            }
        } catch (error) {
            this.setEmptyMessage();
            return;
        }
    }

    async getSectorData() {
        const sectorUrl = UrlTool.addPath(this.fund_portfolio_sector_api, this.fundCode);
        let options = {
            errorHandler: () => {
                this.errorHandler();
            },
            data: {
                asat: this.reportTime,
            },
        };
        const sectorData = await this.httpClient.get(sectorUrl, options);
        return sectorData;
    }

    renderSectorData(sectorData) {
        let sector_a = [];
        let sector_h = [];
        let sectorResData = sectorData.data;
        if (sectorResData !== null && sectorResData.sectorMarkets && sectorResData.sectorMarkets[0].sectorBreakdown) {
            for (let j = 0; j < sectorResData.sectorMarkets.length; j++) {
                let sectorBreakdown = sectorResData.sectorMarkets[j].sectorBreakdown;
                let market = sectorResData.sectorMarkets[j].market;
                if (market == "A") {
                    sector_a = this.getSectorDataArray(sectorBreakdown, market);
                } else if (market == "H") {
                    sector_h = this.getSectorDataArray(sectorBreakdown, market);
                }
            }
        }
        this.updateFundDate(this.reportTime);
        this.generateIndustryDistributionTable(sector_a, sector_h);
    }

    getSectorDataArray(sectorBreakdown, market) {
        var sectordata = [];
        var sector;
        for (let i = 0; i < sectorBreakdown.length; i++) {
            let element = sectorBreakdown[i];
            let fundWT = Number(element.fundWT);
            sector = {
                name: element["sectorName"],
                y: fundWT,
                market: market,
            };
            sectordata.push(sector);
        }
        sectordata.sort(function (a, b) {
            return b["y"] - a["y"];
        });
        return sectordata;
    }

    setEmptyMessage(containerId) {}

    errorHandler() {}

    updateFundDate(date) {}

    generateIndustryDistributionTable(sector_a, sector_h) {}
}

export default CAMCFundIndustryDistribution;
